import {create} from "zustand"; 

interface PaymentStore {
    tabPayment: string;
    setTabPayment: (tabPayment: string) => void;

    viewOrUpdate : string;
    setViewOrUpdate: (viewOrUpdate: string) => void;

    payments: any[];
    setPayments: (payments: any[]) => void;

    dataFilterPayments: any[];
    setDataFilterPayments: (dataFilterPayments: any[]) => void;

    paymentDifferences: any[];
    setPaymentDifferences: (paymentDifferences: any[]) => void;

    dataFilterPaymentDifferences: any[];
    setDataFilterPaymentDifferences: (dataFilterPaymentDifferences: any[]) => void;

    formData: Record<string, any>;
    setFormData: (formData: Record<string, any>) => void;
    
    clientFiles: any[];
    setClientFiles: (clientFiles: any[]) => void;

    banks: any[];
    setBanks: (banks: any[]) => void;

    methods: any[];
    setMethods: (methods: any[]) => void;

    idsInvoicesSelected: any;
    setIdsInvoicesSelected: (idsInvoicesSelected: any) => void;

    slips: any[];
    setSlips: (slips: any[]) => void;

    dataFilterSlips: any[];
    setDataFilterSlips: (dataFilterSlips: any[]) => void;

    openPaiementDifference: boolean;
    setOpenPaiementDifference: (openPaiementDifference: boolean) => void;

    difference: number;
    setDifference: (difference: number) => void;

    differenceCategories: any[];
    setDifferenceCategories: (differenceCategories: any[]) => void;

    idPayment: number;
    setIdPayment: (idPayment: number) => void;

    updatePaymentBool: boolean;
    setUpdatePaymentBool: (updatePaymentBool: boolean) => void;

    createSlipBool : boolean;
    setCreateSlipBool : (createSlipBool : boolean) => void;

    balance: number;
    setBalance: (balance: number) => void;

    appliedAmounts: Record<number, number>;
    setAppliedAmounts: (appliedAmounts: Record<number, number>) => void;

    initialised: boolean;
    setInitialised: (initialised: boolean) => void;

    trueAmount: number;
    setTrueAmount: (trueAmount: number) => void;

    resetPayment : () => void;
}

export const usePaymentStore = create<PaymentStore>((set) => ({
    formData: {},
    setFormData: (formData) => set({formData}),

    tabPayment: "Encaissements",
    setTabPayment: (tabPayment) => set({tabPayment}),

    viewOrUpdate: '',
    setViewOrUpdate: (viewOrUpdate) => set({viewOrUpdate}),

    payments: [],
    setPayments: (payments) => set({payments}),

    dataFilterPayments: [],
    setDataFilterPayments: (dataFilterPayments) => set({dataFilterPayments}),

    paymentDifferences: [],
    setPaymentDifferences: (paymentDifferences) => set({paymentDifferences}),

    dataFilterPaymentDifferences: [],
    setDataFilterPaymentDifferences: (dataFilterPaymentDifferences) => set({dataFilterPaymentDifferences
}),
    clientFiles: [],
    setClientFiles: (clientFiles) => set({clientFiles}),

    banks: [],
    setBanks: (banks) => set({banks}),

    methods: [],
    setMethods: (methods) => set({methods}),

    idPayment: 0,
    setIdPayment: (idPayment) => set({idPayment}),

    idsInvoicesSelected: [],
    setIdsInvoicesSelected: (idsInvoicesSelected) => set({idsInvoicesSelected}),

    slips: [],
    setSlips: (slips) => set({slips}),

    dataFilterSlips: [],
    setDataFilterSlips: (dataFilterSlips) => set({dataFilterSlips}),

    openPaiementDifference: false,
    setOpenPaiementDifference: (openPaiementDifference) => set({openPaiementDifference}),

    difference: 0,
    setDifference: (difference) => set({difference}),

    differenceCategories: [],
    setDifferenceCategories: (differenceCategories) => set({differenceCategories}),

    updatePaymentBool: false,
    setUpdatePaymentBool: (updatePaymentBool) => set({updatePaymentBool}),

    createSlipBool : false,
    setCreateSlipBool : (createSlipBool) => set({createSlipBool}),

    balance: 0,
    setBalance: (balance) => set({balance}),

    appliedAmounts: {},
    setAppliedAmounts: (appliedAmounts) => set({appliedAmounts}),

    initialised: false,
    setInitialised: (initialised) => set({initialised}),

    trueAmount: 0,
    setTrueAmount: (trueAmount) => set({trueAmount}),

    resetPayment: () => set({
        formData: {},
        tabPayment: "Encaissements",
        viewOrUpdate: '',
        dataFilterPayments: [],
        paymentDifferences: [],
        dataFilterPaymentDifferences: [],
        banks: [],
        methods: [],
        idPayment: 0,
        idsInvoicesSelected: [],
        slips: [],
        dataFilterSlips: [],
        openPaiementDifference: false,
        difference: 0,
        differenceCategories: [],
        updatePaymentBool: false,
        createSlipBool : false,
        balance: 0,
        appliedAmounts: {},
        initialised: false,
        trueAmount: 0,
    })
}));
